import { formatDate } from '@/portainer/filters/filters';

import { AlertRulesResponse, AlertRuleRow } from './types';

export function transformToAlertRuleRow(
  alertRules: AlertRulesResponse
): Array<AlertRuleRow> {
  return alertRules.map((alertRule) => ({
    id: alertRule.id,
    isInternal: alertRule.isInternal,
    name: alertRule.name,
    description: alertRule.description,
    enabled: alertRule.enabled,
    severity: alertRule.severity,
    threshold: alertRule.threshold,
    conditionOperator: alertRule.conditionOperator,
    duration: alertRule.duration,
    createdBy: alertRule.createdBy,
    createdAt: formatDate(new Date(alertRule.createdAt)),
    updatedAt: alertRule.updatedAt,
    isEditable: alertRule.isEditable ?? false,
    labels: alertRule.labels,
    summary: alertRule.summary,
    alertManagerID: alertRule.alertManagerID,
    supportedAgentVersion: alertRule.supportedAgentVersion,
    supportedEnvironmentTypes: alertRule.supportedEnvironmentTypes,
  }));
}
